import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    loading: boolean,
    isAuthenticated: boolean,
    accessToken: any;
    userInfo: any;
}
const initialState: InitialState = {
    loading: false,
    isAuthenticated: false,
    accessToken: sessionStorage.getItem("authInformation"),
    userInfo: sessionStorage.getItem("userInfo"),
};

export const authReducer = createSlice({
    name: "auth",
    initialState,
    reducers: {
        loginRequest: (state) => {
            state.loading = true;
            state.isAuthenticated = false;
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            state.isAuthenticated = true;
            state.userInfo = action.payload.data.customerInfo;
            state.accessToken = action.payload.data.token;
            sessionStorage.setItem("authInformation", state.accessToken);
            sessionStorage.setItem('userInfo', state?.userInfo?.userName);
            // sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo[0]));
        },
        loginFailure: (state) => {
            state.loading = false;
            state.isAuthenticated = false;
            state.userInfo = null;
        },

        logout: (state) => {
            state.isAuthenticated = false;
            state.userInfo = null;
            state.accessToken = null;
            sessionStorage.clear();
        }
    },
});

export const { loginRequest, loginSuccess, loginFailure, logout } =
    authReducer.actions;

export default authReducer.reducer;

